<template>
  <div>
    <form @submit.prevent="vLaunchResearch">
      <div class="submission-research">
        <div class="form-field">
          <label>{{$_('submission_code')}}</label>
          <Input :type="'text'" :val="preselected_data.fnsoum" @typing="vSelectedStore('fnsoum', $event)" />
        </div>
        <div class="form-field">
          <label>{{$_('customer_reference')}}</label>
          <Input :type="'text'" @typing="vSelectedStore('frefc', $event)" />
        </div>
        <div class="form-field">
          <label>{{$_('color')}}</label>
          <Input :type="'text'" @typing="vSelectedStore('fcol', $event)" />
        </div>
        <div class="form-field">
          <label>{{$_('status')}}</label>
          <SelectMultiple 
            :data="status_data"
            :placeholder="$_('your_choice')"
            :itemoption="['TID', 'TLIB_ETAT']"
            @selectmultiple:selecting="vSelectedStore('fstatus', $event)"
            :preselected="getPreselected"
          />
        </div>
        <div class="form-field">
          <label>{{$_('from')}}</label>
          <DatePicker 
            @datepicker:select="vSelectedStore('fdate_soum', $event)" 
            class="form-element"
          />
        </div>
        <div class="form-field display-flex justify-content-end">
            <button class="btn">{{$_('research_button')}}</button>
        </div>
            </div> 
        </form>
    </div>

</template>

<script>


import SelectMultiple from '@/common/components/widget/SelectMultiple'
import DatePicker from '@/common/components/widget/DatePicker'
import Input from '@/common/components/widget/Input/Input'

import submissionService from '@/modules/soumission/services/submissionService'

export default {
    data() {
      return {
        status_data: Array(),
        preselected: '',
        preselected_data: {
          fnsoum: ''
        }
      }
    },
    created() {
      submissionService.getResearchStatus()
      .then(res => {
        res.data.DS_O.OUT.map(obj => {
          this.status_data.push({TID: obj.TCETAT, TLIB_ETAT: obj.TLIB_ETAT})
        });

        this.preselected = ['D', 'E', 'A', 'R', '@'];
      })

      if(this.$route.params.submission_id !== undefined) {
        this.preselected_data.fnsoum = this.$route.params.submission_id;
      } else {
        this.vSelectedStore('fnsoum', '');
      }
      
    },
    computed: {
      getPreselected() {
        return this.preselected;
      }
    },
    components: {
      SelectMultiple, 
      DatePicker,
      Input
    },
    methods: {
      vLaunchResearch() {
        this.vSelectedStore('launch_research', true);
        this.vSelectedStore('reset_submission_list', true);
      },
      vSelectedStore(key, value) {
        if(key === 'fstatus') {

          let type = value.type;
        
          switch (value.option) {
            case '@':
              key = 'fcetat';
              value = value.option;
              break;
            case 'D':
              key = 'fcetatd';
              value = value.option;
              break;
            case 'E':
              key = 'fcetate';
              value = value.option;
              break;
            case 'A':
              key = 'fcetata';
              value = value.option;
              break;
            case 'R':
              key = 'fcetatr';
              value = value.option;
              break;
            case 'T':
              key = 'fcetatt';
              value = value.option;
              break;
            case '*':
              key = 'fcetat_sup';
              value = value.option;
              break;
          }

          if(type === 'uncheck') {
            this.$store.dispatch('soumission/DELETE_CRITERIA', {key, value});
          } else if (type === 'uncheckall') {
            this.$store.dispatch('soumission/DELETE_ALL_CRITERIA', {key, value});
          } else {
            this.$store.dispatch('soumission/SELECT', {key, value});
          }

        } else if (key === 'fdate_soum') {

          var DateTmp = value.split('/');
          DateTmp.reverse();
          value = DateTmp.join('');

        } else {
          this.$store.dispatch('soumission/SELECT', {key, value});
        }
      }
    }
}
</script>

<style scoped>
.submission-research {
  background-color: #f5f5f5;
  padding: 20px;
  display: flex;
  flex-wrap: wrap
}
form {
  width: 1;
}
.form-field {
  margin: 5px;
}
label {
  padding-left: 20px;
}
.form-element {
  width: 200px;
}
.select-box {
    margin: auto;
}
</style>